<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Subject:</label>
      <input type="text" class="form-control" v-model="subject" placeholder="subject" />
    </div>

    <div class="form-group">
      <label class="label-form" for="describtion">Answer:</label>
      <div class="text_editor">
        <!-- <jodit-vue v-model="postForm.body" :config="config" /> -->
        <tiny-mce-editor :vModelName.sync="note_description"></tiny-mce-editor><br />
      </div>
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" class="btn btn-primary btn-sm ml-1" @click="save">
        Send
      </button>
    </div>
  </form>
</template>

<script>
  import Multiselect from "vue-multiselect";
  import axios from "axios";
  import TinymceEditor from "../../views/partials/tiny_mce_editor";

  export default {
    props: ["action", "formData"],

    components: {
      Multiselect,
      "tiny-mce-editor": TinymceEditor,
    },

    data: function () {
      return {
        note_description: "",
        subject: "",
      };
    },

    computed: {
      getNote: function () {
           const permission = {
      headers: {
        'X-Permission': 'all_organization_note' 
      }
    };
        axios
          .get("/admin/users/get-user-note?user_id=" + this.formData,permission)
          .then((response) => {
            this.note_description = response.data;
            return response.data;
          });
      },
    },

    methods: {
      save() {
        let self = this;
        let subject = self.subject;
        let note = self.note_description;

        this.$store
          .dispatch("users/sendBulkEmailToOrganization", [subject, note])
          .then(() => {
            //self.note_description = {};
            // send successful message
            this.$store.dispatch(
              "message/update",
              {
                title: "Email",
                body: `Email has been sent successfully to all organizations`,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
            //window.location.reload();
            window.$("#modal").modal("hide");
            this.note_description = "";
            this.subject = "";
          })
          .catch((error) => {
            let response = error.response;

            // send error message
            this.$store.dispatch(
              "message/update",
              {
                title: "Error",
                body: response.data.message,
                itemsErrors: response.data.errors,
                class: "danger",
                confirm: false,
              },
              { root: true }
            );
          });
      },
    },
  };
</script>